import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	reorderErrorTitle: {
		id: 'native-issue-table.services.rank-mutation.reorder-error-title',
		defaultMessage: "We couldn't reorder those issues",
		description: 'Heading text for error flag that appears when reordering fails',
	},
	reorderErrorDescription: {
		id: 'native-issue-table.services.rank-mutation.reorder-error-description',
		defaultMessage: 'Wait a few moments, then give it another try.',
		description: 'Body text for error flag that appears when reordering fails',
	},
	reorderErrorTitleIssueTermRefresh: {
		id: 'native-issue-table.services.rank-mutation.reorder-error-title-issue-term-refresh',
		defaultMessage: "We couldn't reorder those work items",
		description: 'Heading text for error flag that appears when reordering fails',
	},
});
